export const useThemeStore = defineStore('theme', () => {
  // 主题配置常量
  const THEME_STORAGE_KEY = 'localTheme'
  const COLOR_STORAGE_KEY = 'localColor'

  const THEME_VALUES = {
    DARK: 'p-dark',
    LIGHT: 'p-light',
  } as const

  const COLOR_VALUES = {
    GOLD: 'p-gold',
    INDIGO: 'p-indigo',
  } as const

  // 从 localStorage 获取初始值
  const getInitialThemeMode = (): 'light' | 'dark' | 'auto' => {
    const localTheme = localStorage.getItem(THEME_STORAGE_KEY)

    if (localTheme === THEME_VALUES.DARK)
      return 'dark'
    if (localTheme === THEME_VALUES.LIGHT)
      return 'light'
    return 'auto'
  }

  const getInitialThemeColor = (): 'gold' | 'indigo' => {
    const localColor = localStorage.getItem(COLOR_STORAGE_KEY)

    if (localColor === COLOR_VALUES.GOLD)
      return 'gold'
    if (localColor === COLOR_VALUES.INDIGO)
      return 'indigo'
    return 'indigo'
  }

  // 响应式状态
  const mode = ref<'light' | 'dark' | 'auto'>(getInitialThemeMode())
  const color = ref<'gold' | 'indigo'>(getInitialThemeColor())

  const isDark = computed(() => {
    return mode.value === 'auto' ? usePreferredDark().value : mode.value === 'dark'
  })

  // 颜色模式配置
  const colorMode = useColorMode({
    modes: {
      gold: 'light theme-gold',
      darkGold: 'dark theme-gold',
    },
  })

  // 主题映射
  const getThemeMap = () => ({
    indigo: isDark.value ? 'dark' : 'light',
    gold: isDark.value ? 'darkGold' : 'gold',
  } as const)

  // 监听主题变化并应用
  watchEffect(() => {
    const themeMap = getThemeMap()
    colorMode.value = themeMap[color.value]
  })

  // 初始化主题方法
  function initTheme() {
    const localTheme = localStorage.getItem(THEME_STORAGE_KEY)
    const localColor = localStorage.getItem(COLOR_STORAGE_KEY)

    // 更新主题模式
    if (localTheme === THEME_VALUES.DARK) {
      mode.value = 'dark'
    }
    else if (localTheme === THEME_VALUES.LIGHT) {
      mode.value = 'light'
    }
    else {
      mode.value = 'auto'
    }

    // 更新主题色
    if (localColor === COLOR_VALUES.GOLD) {
      color.value = 'gold'
    }
    else if (localColor === COLOR_VALUES.INDIGO) {
      color.value = 'indigo'
    }
    else {
      color.value = 'indigo'
    }
  }

  return {
    mode,
    color,
    isDark,
    initTheme,
  }
})
